import { f as A, F as b } from "./TrailingNode-CvEgs0ER.js";
import { B as Oe, d as Ne, D as Pe, c as Me, H as Ie, L as Ae, N as Le, P as Ve, e as ke, S as Be, h as je, g as Ue, i as _e, T as Re, j as Fe, V as Ye, Y as $e, a as He, b as Ke, s as Je, t as Xe } from "./TrailingNode-CvEgs0ER.js";
import { _ as L } from "./defaultBlocks-B85uW2jE.js";
import { ae as Ze, af as Ge, ah as Qe, ag as We, ad as qe } from "./defaultBlocks-B85uW2jE.js";
import { S as tt } from "./ShowSelection-Dz-NEase.js";
import { revertSuggestions as V, applySuggestions as k, revertSuggestion as B, applySuggestion as j, disableSuggestChanges as U, enableSuggestChanges as _, suggestChanges as R, withSuggestChanges as g } from "@handlewithcare/prosemirror-suggest-changes";
import { getMarkRange as F, posToDOMRect as Y } from "@tiptap/core";
import { c as T, a as $ } from "./BlockNoteExtension-C2X7LW-V.js";
import { yXmlFragmentToProseMirrorRootNode as H } from "y-prosemirror";
import * as f from "yjs";
import { v4 as K } from "uuid";
let h;
async function J() {
  return h || (h = (async () => {
    const [e, t] = await Promise.all([
      import("emoji-mart"),
      // use a dynamic import to encourage bundle-splitting
      // and a smaller initial client bundle size
      import("@emoji-mart/data")
    ]), o = "default" in e ? e.default : e, n = "default" in t ? t.default : t;
    return await o.init({ data: n }), { emojiMart: o, emojiData: n };
  })(), h);
}
async function Ce(e, t) {
  if (!("text" in e.schema.inlineContentSchema) || e.schema.inlineContentSchema.text !== L.text)
    return [];
  const { emojiData: o, emojiMart: n } = await J();
  return (t.trim() === "" ? Object.values(o.emojis) : await n.SearchIndex.search(t)).map((s) => ({
    id: s.skins[0].native,
    onItemClick: () => e.insertInlineContent(s.skins[0].native + " ")
  }));
}
const X = T(({ editor: e }) => {
  function t(a) {
    let s = e.prosemirrorView.nodeDOM(a);
    for (; s && s.parentElement; ) {
      if (s.nodeName === "INS" || s.nodeName === "DEL")
        return s;
      s = s.parentElement;
    }
    return null;
  }
  function o(a, s) {
    return e.transact((l) => {
      const u = l.doc.resolve(a), r = u.marks().find((m) => m.type.name === s);
      if (!r)
        return;
      const i = F(u, r.type);
      if (i)
        return {
          range: i,
          mark: r,
          get text() {
            return l.doc.textBetween(i.from, i.to);
          },
          get position() {
            return Y(
              e.prosemirrorView,
              i.from,
              i.to
            ).toJSON();
          }
        };
    });
  }
  function n() {
    return e.transact((a) => {
      const s = a.selection;
      if (s.empty)
        return o(s.anchor, "insertion") || o(s.anchor, "deletion") || o(s.anchor, "modification");
    });
  }
  return {
    key: "suggestions",
    prosemirrorPlugins: [R()],
    // mount: () => {
    //   const origDispatchTransaction = (
    //     editor._tiptapEditor as any
    //   ).dispatchTransaction.bind(editor._tiptapEditor);
    //   (editor._tiptapEditor as any).dispatchTransaction = withSuggestChanges(
    //     origDispatchTransaction,
    //   );
    // },
    enableSuggestions: () => _(
      e.prosemirrorState,
      e._tiptapEditor.dispatchTransaction.bind(
        e._tiptapEditor
      )
    ),
    disableSuggestions: () => U(
      e.prosemirrorState,
      e._tiptapEditor.dispatchTransaction.bind(
        e._tiptapEditor
      )
    ),
    applySuggestion: (a) => j(a)(
      e.prosemirrorState,
      g(e.prosemirrorView.dispatch).bind(
        e._tiptapEditor
      ),
      e.prosemirrorView
    ),
    revertSuggestion: (a) => B(a)(
      e.prosemirrorState,
      g(e.prosemirrorView.dispatch).bind(
        e._tiptapEditor
      ),
      e.prosemirrorView
    ),
    applyAllSuggestions: () => k(
      e.prosemirrorState,
      g(e.prosemirrorView.dispatch).bind(
        e._tiptapEditor
      )
    ),
    revertAllSuggestions: () => V(
      e.prosemirrorState,
      g(e.prosemirrorView.dispatch).bind(
        e._tiptapEditor
      )
    ),
    getSuggestionElementAtPos: t,
    getMarkAtPos: o,
    getSuggestionAtSelection: n,
    getSuggestionAtCoords: (a) => e.transact(() => {
      const s = e.prosemirrorView.posAtCoords(a);
      if (!(s === null || (s == null ? void 0 : s.inside) === -1))
        return o(s.pos, "insertion") || o(s.pos, "deletion") || o(s.pos, "modification");
    }),
    checkUnresolvedSuggestions: () => {
      let a = !1;
      return e.prosemirrorState.doc.descendants((s) => a ? !1 : (a = s.marks.findIndex(
        (l) => l.type.name === "insertion" || l.type.name === "deletion" || l.type.name === "modification"
      ) !== -1, !0)), a;
    }
  };
}), be = T(
  ({
    editor: e,
    options: { endpoints: t, fragment: o }
  }) => {
    const n = $({
      snapshots: [],
      selectedSnapshotId: void 0
    }), a = (r) => {
      const i = new f.Doc();
      f.applyUpdateV2(i, r);
      const m = A(o, i), I = H(
        m,
        e.prosemirrorState.schema
      );
      e.transact((C) => {
        C.replace(0, C.doc.content.size - 2, I.slice(0));
      });
    }, s = async () => {
      const r = await t.listSnapshots();
      n.setState((i) => ({
        ...i,
        snapshots: r
      }));
    }, l = async () => {
      if (await s(), n.state.snapshots.length > 0) {
        const r = await t.fetchSnapshotContent(
          n.state.snapshots[0].id
        );
        a(r);
      }
    }, u = async (r) => {
      if (n.setState((m) => ({
        ...m,
        selectedSnapshotId: r
      })), r === void 0) {
        e.getExtension(b).merge({ keepChanges: !1 });
        return;
      }
      e.getExtension(b).fork();
      const i = await t.fetchSnapshotContent(r);
      a(i);
    };
    return {
      key: "versioning",
      store: n,
      mount: () => {
        l();
      },
      listSnapshots: async () => (await s(), n.state.snapshots),
      createSnapshot: async (r) => (await t.createSnapshot(o, r), await s(), n.state.snapshots[0]),
      canRestoreSnapshot: t.restoreSnapshot !== void 0,
      restoreSnapshot: t.restoreSnapshot ? async (r) => {
        u(void 0);
        const i = await t.restoreSnapshot(
          o,
          r
        );
        return a(i), await s(), i;
      } : void 0,
      canUpdateSnapshotName: t.updateSnapshotName !== void 0,
      updateSnapshotName: t.updateSnapshotName ? async (r, i) => {
        await t.updateSnapshotName(r, i), await s();
      } : void 0,
      selectSnapshot: async (r) => {
        const i = e.getExtension(X);
        i !== void 0 && i.disableSuggestions(), await u(r);
      }
    };
  }
), z = String.fromCharCode, Z = (e) => e.toLowerCase(), G = /^\s*/g, Q = (e) => e.replace(G, ""), W = /([A-Z])/g, v = (e, t) => Q(e.replace(W, (o) => `${t}${Z(o)}`));
typeof TextEncoder < "u" && new TextEncoder();
let S = typeof TextDecoder > "u" ? null : new TextDecoder("utf-8", { fatal: !0, ignoreBOM: !0 });
S && S.decode(new Uint8Array()).length === 1 && (S = null);
const w = () => /* @__PURE__ */ new Map(), D = (e) => e === void 0 ? null : e;
class q {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  /**
   * @param {string} key
   * @param {any} newValue
   */
  setItem(t, o) {
    this.map.set(t, o);
  }
  /**
   * @param {string} key
   */
  getItem(t) {
    return this.map.get(t);
  }
}
let O = new q(), ee = !0;
try {
  typeof localStorage < "u" && localStorage && (O = localStorage, ee = !1);
} catch {
}
const te = O, oe = (e, t) => t.includes(e), p = typeof process < "u" && process.release && /node|io\.js/.test(process.release.name) && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]", N = typeof window < "u" && typeof document < "u" && !p;
let c;
const ne = () => {
  if (c === void 0)
    if (p) {
      c = w();
      const e = process.argv;
      let t = null;
      for (let o = 0; o < e.length; o++) {
        const n = e[o];
        n[0] === "-" ? (t !== null && c.set(t, ""), t = n) : t !== null && (c.set(t, n), t = null);
      }
      t !== null && c.set(t, "");
    } else typeof location == "object" ? (c = w(), (location.search || "?").slice(1).split("&").forEach((e) => {
      if (e.length !== 0) {
        const [t, o] = e.split("=");
        c.set(`--${v(t, "-")}`, o), c.set(`-${v(t, "-")}`, o);
      }
    })) : c = w();
  return c;
}, y = (e) => ne().has(e), E = (e) => D(p ? process.env[e.toUpperCase().replaceAll("-", "_")] : te.getItem(e)), P = (e) => y("--" + e) || E(e) !== null;
P("production");
const se = p && oe(process.env.FORCE_COLOR, ["true", "1", "2"]);
se || !y("--no-colors") && // @todo deprecate --no-colors
!P("no-color") && (!p || process.stdout.isTTY) && (!p || y("--color") || E("COLORTERM") !== null || (E("TERM") || "").includes("color"));
const ae = (e) => new Uint8Array(e), re = (e, t, o) => new Uint8Array(e, t, o), ie = (e) => {
  let t = "";
  for (let o = 0; o < e.byteLength; o++)
    t += z(e[o]);
  return btoa(t);
}, ce = (e) => Buffer.from(e.buffer, e.byteOffset, e.byteLength).toString("base64"), le = (e) => {
  const t = atob(e), o = ae(t.length);
  for (let n = 0; n < t.length; n++)
    o[n] = t.charCodeAt(n);
  return o;
}, pe = (e) => {
  const t = Buffer.from(e, "base64");
  return re(t.buffer, t.byteOffset, t.byteLength);
}, ue = N ? ie : ce, me = N ? le : pe, d = async () => JSON.parse(localStorage.getItem("snapshots") ?? "[]"), x = async (e, t, o) => {
  const n = {
    id: K(),
    name: t,
    createdAt: Date.now(),
    updatedAt: Date.now(),
    meta: {
      restoredFromSnapshotId: o,
      userIds: ["User1"],
      contents: ue(f.encodeStateAsUpdateV2(e.doc))
    }
  };
  return localStorage.setItem(
    "snapshots",
    JSON.stringify([n, ...await d()])
  ), Promise.resolve(n);
}, M = async (e) => {
  const o = (await d()).find(
    (n) => n.id === e
  );
  if (o === void 0)
    throw new Error(`Document snapshot ${e} could not be found.`);
  if (!("contents" in o.meta))
    throw new Error(`Document snapshot ${e} doesn't contain content.`);
  if (typeof o.meta.contents != "string")
    throw new Error(`Document snapshot ${e} contains invalid content.`);
  return Promise.resolve(me(o.meta.contents));
}, fe = async (e, t) => {
  await x(e, "Backup");
  const o = await M(t), n = new f.Doc();
  return f.applyUpdateV2(n, o), await x(n.getXmlFragment(), "Restored Snapshot", t), o;
}, ge = async (e, t) => {
  const o = await d(), n = o.find(
    (a) => a.id === e
  );
  if (n === void 0)
    throw new Error(`Document snapshot ${e} could not be found.`);
  return n.name = t, n.updatedAt = Date.now(), localStorage.setItem("snapshots", JSON.stringify(o)), Promise.resolve();
}, ve = {
  listSnapshots: d,
  createSnapshot: x,
  fetchSnapshotContent: M,
  restoreSnapshot: fe,
  updateSnapshotName: ge
};
export {
  Oe as BlockChangeExtension,
  Ne as DEFAULT_LINK_PROTOCOL,
  Pe as DropCursorExtension,
  Ze as FilePanelExtension,
  b as ForkYDocExtension,
  Me as FormattingToolbarExtension,
  Ie as HistoryExtension,
  Ae as LinkToolbarExtension,
  Le as NodeSelectionKeyboardExtension,
  Ve as PlaceholderExtension,
  ke as PreviousBlockTypeExtension,
  Be as SchemaMigration,
  tt as ShowSelectionExtension,
  je as SideMenuExtension,
  Ue as SideMenuView,
  Ge as SuggestionMenu,
  X as SuggestionsExtension,
  _e as TableHandlesExtension,
  Re as TableHandlesView,
  Fe as TrailingNodeExtension,
  Ye as VALID_LINK_PROTOCOLS,
  be as VersioningExtension,
  $e as YCursorExtension,
  He as YSyncExtension,
  Ke as YUndoExtension,
  Qe as filterSuggestionItems,
  A as findTypeInOtherYdoc,
  Ce as getDefaultEmojiPickerItems,
  We as getDefaultSlashMenuItems,
  qe as insertOrUpdateBlockForSlashMenu,
  ve as localStorageEndpoints,
  Je as sideMenuPluginKey,
  Xe as tableHandlesPluginKey
};
//# sourceMappingURL=extensions.js.map
